import * as Yup from "yup";

export interface OrderDateFormValues {
  preBookDeliveryDate: Date | undefined;
}

export const deliveryDateValidationSchema = Yup.object().shape({
  preBookDeliveryDate: Yup.date().required(),
});
